setCookie('firstVisit', false);
import {HoverSlider} from './splide-extension-hover-slider.js';

const {AutoScroll} = window.splide.Extensions;

document.addEventListener('DOMContentLoaded', function () {

    waitForMediaLoad().then(function () {

        document.getElementById('loadingScreen')?.classList.add('loaded');

        var elms = document.getElementsByClassName('splide');
        if (elms.length) {
            for (var i = 0; i < elms.length; i++) {
                const splide = new Splide(elms[i], {
                    type: 'loop',
                    // snap: true,
                    perPage: -1,
                    autoWidth: true,
                    height: '387px',
                    autoScroll: {
                        speed: .9,
                        pauseOnHover: false,
                        autoStart: false,
                    },
                    // mediaQuery: 'min',
                    breakpoints: {
                        980: {
                            height: '243px',
                            perPage: 4,
                        },

                        768: {
                            perPage: 1,
                        }
                    }
                });

                splide.on('drag', function () {
                    $('.work__item__images').addClass('dragging');
                    $('.work__item__image').removeClass('hover');
                });

                splide.on('dragged', function () {
                    $('.work__item__images').removeClass('dragging');
                });


                // Hover of work items
                // document.querySelectorAll('section.work .work__item__images').forEach(function (workSection, idx) {
                //     if (window.innerWidth >= 769) {
                //         workSection.addEventListener('mouseenter', function () {
                //             $(workSection).find('video').each(function () {
                //                 this.play();
                //             })
                //         });
                //         workSection.addEventListener('mouseleave', function () {
                //             $(workSection).find('video').each(function () {
                //                 this.pause();
                //             })
                //         });
                //     }
                // });

                // Hover of work item
                document.querySelectorAll('.work__item__image').forEach(function (item, idx) {
                    item.addEventListener('mouseenter', function () {
                        this.classList.add('hover');
                    });
                    item.addEventListener('mouseleave', function () {
                        this.classList.remove('hover');
                    });
                });

                function splide_init(current_splide) {
                    if (window.innerWidth >= 980) {
                        current_splide.mount({
                            AutoScroll,
                            HoverSlider
                        });
                    } else {
                        current_splide.mount({
                            HoverSlider
                        });
                    }
                }

                async function splideOnLoad() {
                    await aspectRatios().then(() => {
                        autoPlayVideos();
                        splide_init(splide);
                        fadeInItems()
                    });
                }

                function autoPlayVideos() {
                    const videos = document.querySelectorAll('section.work .work__item__images');
                    if (window.innerWidth <= 768) {
                        videos.forEach(function (workSection, idx) {
                            $(workSection).find('video').each(function () {
                                this.play();
                            })
                        });
                    }
                }

                function aspectRatios() {
                    return new Promise((resolve) => {
                        const videos = document.querySelectorAll('.work__item__video video');
                        const timer = setInterval(() => {
                            videos.forEach(function (e) {
                                if (e.videoWidth) {
                                    e.parentElement.style.aspectRatio = e.videoWidth + '/' + e.videoHeight;
                                }
                            })
                            clearInterval(timer);
                        }, 100);
                        resolve();
                    })
                }

                // init
                splideOnLoad();


                $(window).on('resize', function () {
                    splide.destroy();
                    splide_init(splide);
                    autoPlayVideos();
                    fadeInItems()
                })

                window.addEventListener('scroll', () => {
                    fadeInItems()
                })
            }
        }
    }).catch(function (error) {
        console.error('Some media failed to load:', error);
    });

    function fadeInItems() {
        const items = document.querySelectorAll('.work__item__images');

        items.forEach((imageWrapper) => {
            if (isInViewport(imageWrapper)) {
                imageWrapper.querySelectorAll('.work__item__image').forEach((image, i = 1) => {
                    setTimeout(function () {
                        image.classList.add('fade-in');
                    }, i * 80)
                    i++;
                })
            }
        })
    }

    $(document).on('click', '.work__item__video__volume-up', function () {
        const video = $(this).prev('video');
        $(this).removeClass('active');
        video[0].muted = !video[0].muted;
        $(this).next().addClass('active');
    })

    $(document).on('click', '.work__item__video__volume-down', function () {
        const video = $(this).prev().prev('video');
        $(this).removeClass('active');
        video[0].muted = !video[0].muted;
        $(this).prev().addClass('active');
    })

    // Work Flyout
    document.querySelectorAll('body.single .work__item__link--more-info a').forEach(function (item, idx) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const flyoutID = this.hash;
            if (flyoutID) {
                closeWorkFlyout()
                document.body.classList.add('flyout-active');
                document.querySelector(flyoutID).classList.add('work__flyout--active');
            }
        })
    });

    document.querySelectorAll('.work__flyout__close').forEach(function (closeButton, idx) {
        closeButton.addEventListener('click', closeWorkFlyout);
    })

    if (document.body.classList.contains('single')) {
        document.querySelector('.work__flyout-overlay').addEventListener('click', closeWorkFlyout)
    }

});

function isInViewport(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height() + 300;

    return elementBottom > viewportTop && elementTop < viewportBottom;
}


function closeWorkFlyout() {
    document.body.classList.remove('flyout-active');
    document.querySelectorAll('.work__flyout').forEach(function (workFlyout, idx) {
        workFlyout.classList.remove('work__flyout--active');
    })
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null;
}


// Define a function to wait for all images and videos to load
function waitForMediaLoad() {
    return new Promise((resolve, reject) => {
        // Get all image and video elements on the page
        const mediaElements = Array.from(document.querySelectorAll('img')).concat(
            Array.from(document.querySelectorAll('video'))
        );

        // If there are no media elements, resolve immediately
        if (mediaElements.length === 0) {
            resolve();
            return;
        }

        // Map each media element to a promise
        const mediaPromises = mediaElements.map(function (media) {
            return new Promise(function (resolve, reject) {
                if (media.tagName === 'IMG') {
                    // For images
                    if (media.complete && media.naturalWidth > 0) {
                        // Image already loaded
                        resolve();
                    } else {
                        // Wait for the image to load or fail
                        media.addEventListener('load', function () {
                            resolve();
                        });
                        media.addEventListener('error', function () {
                            reject(new Error('Image failed to load: ' + media.src));
                        });
                    }
                } else if (media.tagName === 'VIDEO') {

                    media.load();

                    // For videos
                    if (media.readyState >= 4) {
                        // Video already loaded
                        resolve();
                    } else {
                        // Wait for the video to load metadata and data
                        media.addEventListener('loadeddata', function () {
                            resolve();
                        });
                        media.addEventListener('error', function () {
                            resolve(new Error('Video failed to load: ' + media.src));
                        });
                    }
                }
            });
        });

        // Wait for all media promises to resolve
        Promise.all(mediaPromises)
            .then(resolve)
            .catch(reject);
    });
}
